// src/pages/Utility/StikerPrint.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';


import backlogo from '../../Assets/App_icon/back.png';
import gmaplogo from '../../Assets/App_icon/gmap.png';

const OrderMaster = () => {
  
  

  const navigate = useNavigate();
  
  const [text, setText] = useState('');
  const [line1, setLine1] = useState('-');
  const [line2, setLine2] = useState('-');
  const [line3, setLine3] = useState('-');
 
 

  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
            handleBack();
          }        
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, []);
   

    const printLabel50x25 = () => {
      const width = 400;
      const height = 300;

      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      const printWindow = window.open(
        "",
        "",
        `width=${width},height=${height},left=${left},top=${top}`
      );

      const formatCustId = () => {
        const str = " ";
        if (str.length <= 5) return str;
        return str.slice(0, 5) + "  " + str.slice(5);
      };

      printWindow.document.write(`
        <html>
          <head>
            <title>Print Label</title>
            <style>
              @page {
                size: 50mm 25mm;
                margin: 0;
              }

              html, body {
                width: 50mm;
                margin: 0;
                padding: 0;
              }

              body {
                font-family: Arial, sans-serif;
                font-size: 14px;
                text-align: center;
              }

              .label {
                width: 50mm;
                height: 25mm;
                box-sizing: border-box;
                padding: 2mm;
                overflow: hidden;
              }

              .cust-name {
                font-weight: bold;
                font-size: 14px;
                line-height: 1.3;
                white-space: normal;
                word-break: break-word;
              }

              .spacer {
                height: 3mm;   /* 👈 adjust this as needed */
              }
              .spacerArea {
                height: 1mm;   /* 👈 adjust this as needed */
              }
            </style>
          </head>
          <body>
            <div class="label">
              <div class="spacerArea"> </div>
              <div class="cust-name">${line1}</div>
              <div class="spacer"> </div>
              <div class="cust-name">${line2}</div>
              <div class="spacer"> </div>
              <div class="cust-name">${line3}</div>
            </div>
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.focus();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 300);
    };

   
    
  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div></div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Stiker Print</b>
              <div> </div>
          </div>

          <div
            style={{
              width: "100%",
              background: "#e6e6e6",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ width: "300px" }}>

              {/* INPUT */}
              <input
                type="text"
                placeholder="Enter 1st Line"
                maxLength={15}
                onChange={(e) => setLine1(e.target.value)} 
                style={{
                  width: "100%",
                  border: "none",
                  borderRadius: "8px",
                  textAlign: "center",
                  fontSize: "20px",
                  marginTop: "50px",
                  marginBottom: "10px",
                  outline: "none",
                }}
              />

              <input
                type="text"
                placeholder="Enter 2nd Line"
                maxLength={15}
                onChange={(e) => setLine2(e.target.value)} 
                style={{
                  width: "100%",
                  border: "none",
                  borderRadius: "8px",
                  textAlign: "center",
                  fontSize: "20px",
                  marginBottom: "10px",
                  outline: "none",
                }}
              />

              <input
                type="text"
                placeholder="Enter 3rd Line"
                maxLength={15}
                onChange={(e) => setLine3(e.target.value)} 
                style={{
                  width: "100%",
                  border: "none",
                  borderRadius: "8px",
                  textAlign: "center",
                  fontSize: "20px",
                  marginBottom: "20px",
                  outline: "none",
                }}
              />

              {/* BUTTONS */}
              <div style={{ display: "flex", gap: "20px" }}>
                <Button color="success" style={{ marginLeft: '10px', marginRight: '10px' }} onClick={printLabel50x25}>
                  Print
                </Button>

                <Button color="primary" style={{ marginLeft: '10px', marginRight: '10px' }} onClick={handleBack}>
                  Close
                </Button>
                
              </div>

            </div>
          </div>
    </div>
  );
};

export default OrderMaster;
